import { module as BaseModule } from "modujs";

const SELECTORS = {
  iframe: "iframe",
};

const YOUTUBE_API_SRC = "https://www.youtube.com/iframe_api";
const PLAYER_STATE_PLAYING = 1;

let apiReadyPromise = null;
let apiScriptRequested = false;
const instances = new Set();

const loadYoutubeApi = () => {
  if (typeof window === "undefined") {
    return Promise.resolve(null);
  }

  if (window.YT?.Player) {
    return Promise.resolve(window.YT);
  }

  if (apiReadyPromise) {
    return apiReadyPromise;
  }

  apiReadyPromise = new Promise((resolve) => {
    const previousReady = window.onYouTubeIframeAPIReady;

    window.onYouTubeIframeAPIReady = () => {
      if (typeof previousReady === "function") {
        previousReady();
      }

      resolve(window.YT);
    };

    if (!apiScriptRequested) {
      const script = document.createElement("script");
      script.src = YOUTUBE_API_SRC;
      script.async = true;
      document.head.appendChild(script);
      apiScriptRequested = true;
    }
  });

  return apiReadyPromise;
};

const pauseOtherPlayers = (activeInstance) => {
  instances.forEach((instance) => {
    if (instance !== activeInstance) {
      instance.pause();
    }
  });
};

export default class YoutubeVideo extends BaseModule {
  init() {
    this.iframe = this.el.querySelector(SELECTORS.iframe);

    if (!this.iframe) {
      return;
    }

    instances.add(this);
    this.handlePlayerStateChange = this.handlePlayerStateChange.bind(this);
    this.initPlayer();
  }

  async initPlayer() {
    const YT = await loadYoutubeApi();

    if (!YT?.Player || !this.iframe?.isConnected) {
      return;
    }

    this.player = new YT.Player(this.iframe, {
      events: {
        onStateChange: this.handlePlayerStateChange,
      },
    });
  }

  handlePlayerStateChange(event) {
    if (event?.data === PLAYER_STATE_PLAYING) {
      pauseOtherPlayers(this);
    }
  }

  pause() {
    if (!this.player || typeof this.player.pauseVideo !== "function") {
      return;
    }

    const state =
      typeof this.player.getPlayerState === "function"
        ? this.player.getPlayerState()
        : null;

    if (state === PLAYER_STATE_PLAYING) {
      this.player.pauseVideo();
    }
  }

  destroy() {
    instances.delete(this);

    if (this.player && typeof this.player.destroy === "function") {
      this.player.destroy();
    }

    this.player = null;
    this.iframe = null;
  }
}
